import { supabase } from '@/integrations/supabase/client';

export interface GovernanceReportResponse {
  html: string;
}

export interface GovernanceReportRecord {
  id: string;
  details: {
    file_path?: string;
    timestamp?: string;
  };
  created_at: string;
  user_id: string;
}

/**
 * Generate a governance compliance report for a company using database RPC
 */
export async function generateGovernanceReport(companyId: string): Promise<string> {
  const { data, error } = await supabase.rpc('generate_governance_report', {
    p_company: companyId,
  });

  if (error) {
    console.error('Error generating governance report:', error);
    throw error;
  }

  return data as string;
}

/**
 * Load historical governance reports for a company
 */
export async function loadGovernanceReports(companyId: string): Promise<GovernanceReportRecord[]> {
  const { data, error } = await supabase
    .from('audit_log')
    .select('id, details, created_at, user_id')
    .eq('action', 'GOVERNANCE_REPORT_GENERATED')
    .eq('company_id', companyId)
    .order('created_at', { ascending: false });

  if (error) {
    console.error('Error loading governance reports:', error);
    throw error;
  }

  return (data || []) as GovernanceReportRecord[];
}

/**
 * Download HTML report as a file
 */
export function downloadReport(html: string, companyName: string): void {
  const blob = new Blob([html], { type: 'text/html' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${companyName}-governance-report-${new Date().toISOString().split('T')[0]}.html`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
